export default {
  setPatients(state, patients) {
    state.patients = patients
  },
  setPatient(state, patient) {
    if (state.patient.data) {
      state.patient = patient.data
    } else {
      state.patient = patient
    }
  },
  setPatientsOffset(state, offset) {
    state.patientsOffset = offset
  },
  setPatientsCount(state, count) {
    state.patientsCount = count
  },
  setPatientsNext(state, next) {
    state.patientsNext = next
  },
  setSearchTermLastName(state, lastName) {
    state.searchTermLastName = lastName
  },
  setExternalUploadLink(state, link) {
    state.externalUploadLink = link
  },
  setSearchTermFirstName(state, firstName) {
    state.searchTermFirstName = firstName
  },
  setSearchOrder(state, order) {
    state.searchOrder = order
  },
  setSearchTermBirthdate(state, birthdate) {
    state.searchTermBirthdate = birthdate
  },
  setFiles(state, files) {
    state.files = files
  },
  setRequests(state, requests) {
    state.requests = requests
  },
  setMedResults(state, medResults) {
    state.medResults = medResults
  },
  setProbResults(state, probResults) {
    state.probResults = probResults
  },
  setPermissions(state, permissions) {
    state.permissions = permissions
  },
  setUserGroupsPermissions(state, permissions) {
    state.userGroups = permissions
  },
  setSharedFilesExpiration(state, expiration) {
    state.sharedFilesExpiration = expiration
  },
  setIndividualPermissions(state, permissions) {
    state.individualPermissions = permissions
  },
  setPreliminaryPermissions(state, permissions) {
    state.preliminaryPermissions = permissions
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/patient/mutations.js